module.exports = __webpack_public_path__ + "static/media/gallery2.d55352db.jpg";